module.exports = __webpack_public_path__ + "dcb74ba3add74bf932c5ba8025192bce.pdf";